import { EShareScene } from '../../../../types/yibao';

export const tabTitles = {
  'BasicInfo': '基础信息',
  'ShopInfo': '店铺信息',
  'BindBank': '绑卡管理',
  'Withdrawal': '提现记录',
  'TransactionFlow': '交易流水',
  'PaymentStatement': '交易流水',
  'Statements': '对账单',
  'ReceiptDownload': '回单下载',
  'WithoutPassword': '免密授权',
  'BeneficiaryInfo': '受益人信息',
  'Registration': '注册信息',
  'RegisterInfo': '注册信息',
  'PayInfo': '注册信息',
  'YibaoAccountInfo': '易宝账户信息',
  'ElectronicHouseholdInfo': '电子户信息',
  'OfflinePaymentInfo': '线下收款信息',
  'BankElectronicAccount': '银行电子户',
  'YibaoPaymentChannel': '收款通道'
};


export const Comps = {
  [EShareScene.SupplierPayment]: [
    {
      name: '供应商协议',
      type: 'upload',
    },
    {
      name: '系统首页截图',
      type: 'img',
    },
  ],
  [EShareScene.FranchiseAccountsReceivable]: [
    {
      name: '场景照片',
      desc: '内部售货场景',
      type: 'img',
    },
    {
      name: '办公场景照片',
      type: 'img',
    },
    {
      name: '宣传介绍',
      type: 'textarea',
    },
  ],
  [EShareScene.PromotionRebate]: [
    {
      name: '返佣系统截图',
      type: 'img',
    },
    {
      name: '返佣介绍截图',
      type: 'img',
    },
    {
      name: '返佣合作协议',
      type: 'upload',
    },
  ],
  [EShareScene.ProviderServiceFee]: [
    {
      name: '合同协议',
      desc: '平台网站/APP/公众号/小程序补贴协议',
      type: 'upload',
    },
  ],
  [EShareScene.PlatformSubsidy]: [
    {
      name: '补贴协议',
      desc: '已签约的可以体现收费方式的协议等',
      type: 'upload',
    },
  ],
  [EShareScene.SettledMerchantsReceivable]: [
    {
      name: '代收款协议',
      desc: '提供一个分账方和被分账方已签约的代收款协议',
      type: 'upload',
    },
  ],
  [EShareScene.ReceivableByOwner]: [
    {
      name: '店面场景照片',
      type: 'img',
    },
    {
      name: '收款方场景照片',
      type: 'img',
    },
    {
      name: '代售协议',
      type: 'upload',
    },
  ],
  [EShareScene.AccountsReceivable]: [
    {
      name: '合作协议',
      type: 'upload',
    },
  ],
  [EShareScene.LoanServiceFee]: [
    {
      name: '合作协议',
      type: 'upload',
    },
  ],
  [EShareScene.DepositReceive]: [
    {
      name: '充值储值截图',
      type: 'img',
    },
    {
      name: '返佣介绍截图',
      type: 'img',
    },
  ],
};
